<div class="card-header bg-white" *ngIf="accessService.authorized(project, 'EDIT_RISKS')">

    <ng-template #authTemplate><div [innerHtml]="accessService.authReason(project, 'EDIT_RISKS')"></div></ng-template>
    <button type="button" class="btn btn-primary" placement="right" containerClass="auth-tooltip"
            *ngIf="viewMode === ViewMode.VIEW"
            (click)="setMode(ViewMode.EDIT)"
            [tooltip]="authTemplate"
            [delay]="500">Bearbeiten
    </button>

    <ng-container *ngIf="viewMode === ViewMode.EDIT">
        <button type="button" class="btn btn-success" [disabled]="form.invalid" (click)="update()">Speichern</button>
        <button type="button" class="btn btn-secondary ms-2" (click)="cancelEdit()">Abbrechen</button>
    </ng-container>
</div>
<div class="card-body">
    <form [formGroup]="form">
        <label>Risiken ({{getLengthOfFormArray('risks')}})</label>

        <p *ngIf="getLengthOfFormArray('risks') === 0">Keine Risiken definiert.</p>

        <table class="table table-striped table-sm mb-0" *ngIf="getLengthOfFormArray('risks') > 0">
            <thead>
            <tr>
                <th style="width: 50px" *ngIf="viewMode !== ViewMode.VIEW"></th>
                <th>Risiko</th>
                <th>Ursache</th>
                <th>Auswirkung</th>
                <th>Eintrittswahrscheinlichkeit [%]</th>
                <th>Maßnahmen</th>
                <th>Eintrittswahrscheinlichkeit nach Maßnahme [%]</th>
            </tr>
            </thead>
            <tbody formArrayName="risks">
            <tr [formGroupName]="i"
                *ngFor="let entry of formService.getFormArray(form, 'risks').controls; let i = index">
                <ng-container *ngIf="!entry.value._deleted">
                    <td *ngIf="viewMode !== ViewMode.VIEW">
                        <button type="button" class="btn btn-danger btn-sm" (click)="markEntryAsDeleted(entry)"><i
                                class="fas fa-times"></i></button>
                    </td>
                    <td>
                        <input type="text" class="form-control" formControlName="name" *ngIf="viewMode !== ViewMode.VIEW">
                        <ng-container *ngIf="viewMode === ViewMode.VIEW">{{ entry.value.name }}</ng-container>
                    </td>
                    <td>
                        <input type="text" class="form-control" formControlName="cause" *ngIf="viewMode !== ViewMode.VIEW">
                        <ng-container *ngIf="viewMode === ViewMode.VIEW">{{ entry.value.cause }}</ng-container>
                    </td>
                    <td>
                        <input type="text" class="form-control" formControlName="impact" *ngIf="viewMode !== ViewMode.VIEW">
                        <ng-container *ngIf="viewMode === ViewMode.VIEW">{{ entry.value.impact }}</ng-container>
                    </td>
                    <td>
                        <select class="form-control" formControlName="probability" *ngIf="viewMode !== ViewMode.VIEW">
                            <option value="" disabled selected style="display: none;">Bitte auswählen</option>
                            <option *ngFor="let number of [0,10,20,30,40,50,60,70,80,90,100]" [value]="number">{{number}}</option>
                        </select>
                        <ng-container *ngIf="viewMode === ViewMode.VIEW">{{ entry.value.probability }}</ng-container>
                    </td>
                    <td>
                        <input type="text" class="form-control" formControlName="measures" *ngIf="viewMode !== ViewMode.VIEW">
                        <ng-container *ngIf="viewMode === ViewMode.VIEW">{{ entry.value.measures }}</ng-container>
                    </td>
                    <td>
                        <select class="form-control" formControlName="probability_after" *ngIf="viewMode !== ViewMode.VIEW">
                            <option value="" disabled selected style="display: none;">Bitte auswählen</option>
                            <option *ngFor="let number of [0,10,20,30,40,50,60,70,80,90,100]" [value]="number">{{number}}</option>
                        </select>
                        <ng-container *ngIf="viewMode === ViewMode.VIEW">{{ entry.value.probability_after }}</ng-container>
                    </td>
                </ng-container>
            </tr>
            </tbody>
        </table>

        <div *ngIf="viewMode !== ViewMode.VIEW">
            <button type="button" class="btn btn-primary btn-sm mb-3" (click)="addFormItem({}, 'risks')">
                <i class="fas fa-plus"></i> Risiko hinzufügen
            </button>

            <p>Unsichere Ereignisse oder Bedingungen, die im Eintrittsfall einen positiven oder negativen Einfluss auf ein oder mehrere Projektziele haben.</p>
        </div>

    </form>
</div>
